import { useUserState } from 'context/User';
import allRoles, { hasRole } from 'helpers/Roles';
import {
  IS_UXBEAUTY,
  UserStateContextType
} from 'components/constants/Constants';
import { LoggedInUser } from 'types/User';
import { BrandPortalPermissionKey, PortalPermissionLevel } from 'portals/types';

// Determines whether the user is an event member based on the key.
const getPermission = (
  user: LoggedInUser,
  key: string,
  permission: BrandPortalPermissionKey,
  permissionLevel: PortalPermissionLevel
) =>
  user?.brandPortalEvent?.find(event => event.key === key)?.permissions?.[
    permission
  ] === permissionLevel || hasRole(allRoles.CHEMBERRY_SUPPORT, user);

const useSupplierPortalUser = (key: string | undefined) => {
  const userState = useUserState();

  if (
    IS_UXBEAUTY ||
    !key ||
    userState.type !== UserStateContextType.AUTHENTICATED
  ) {
    return {
      hasSearchViewPermission: false,
      hasProductManagePermission: false,
      hasUserManagePermission: false,
      hasCompanyManagePermission: false,
      hasDocumentManagePermission: false
    };
  }

  return {
    hasSearchViewPermission: getPermission(
      userState.user,
      key,
      BrandPortalPermissionKey.SEARCH,
      PortalPermissionLevel.VIEW
    ),
    hasProductManagePermission: getPermission(
      userState.user,
      key,
      BrandPortalPermissionKey.PRODUCT_MANAGEMENT,
      PortalPermissionLevel.MANAGE
    ),
    hasUserManagePermission: getPermission(
      userState.user,
      key,
      BrandPortalPermissionKey.USER_MANAGEMENT,
      PortalPermissionLevel.MANAGE
    ),
    hasCompanyManagePermission: getPermission(
      userState.user,
      key,
      BrandPortalPermissionKey.COMPANY_MANAGEMENT,
      PortalPermissionLevel.MANAGE
    ),
    hasDocumentManagePermission: getPermission(
      userState.user,
      key,
      BrandPortalPermissionKey.DOCUMENT_MANAGEMENT,
      PortalPermissionLevel.MANAGE
    )
  };
};

export default useSupplierPortalUser;
